module.exports = __webpack_public_path__ + "static/media/Eclectic Gallery Wall DIY Tutorial_0006.efe4bb1d.jpg";